<template>
  <div class="container">
    <common-table
      :data="tableData"
      ref="commonTable"
      @handleChange="getPage"
      :isShow="false"
    >
      <el-table-column
        prop="realName"
        label="姓名"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="idCard"
        label="身份证号"
        min-width="230"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
      </el-table-column>
      <el-table-column prop="realImg" label="签约预览图" min-width="120">
        <template slot-scope="scope">
          <image-viewer
            class="iconUrl"
            :src="scope.row.realImg"
            alt="图片描述"
          ></image-viewer>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="160">
        <template slot-scope="scope">
          <el-button type="text" @click="handleDetail(scope.row)"
            >认证签约明细</el-button
          >
          <el-button type="text" @click="countersign(scope.row)"
            >重签</el-button
          >
        </template>
      </el-table-column>
    </common-table>
    <show-info-dialog dialogWidth="600px" ref="showInfoDialog" title="预览">
      <!-- <div class="recommendPage">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="item in imageUrl" :key="item.id">
            <img
              v-if="item.url == null || item.url == ''"
              class="showImage flex-row absolute-center"
              src="../../../../src/assets/images/noimg.png"
              alt=""
            />
            <img
              v-else
              class="showImage flex-row absolute-center"
              :src="item.url"
              alt=""
            />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div> -->
      <div class="bg">
        <iframe
          :src="server + '/aggrement/index.html?userId=' + imageUrl.userId"
          frameborder="0"
          style="width: 100%; height: 100%"
        ></iframe>
      </div>
    </show-info-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import SelectOrgans from "components/business/SelectOrgans";
import ShowInfoDialog from "@/view/dialog/ShowInfoDialog";
import ImageViewer from "../../dialog/ImageViewer";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import Server from "common/conf/Server";

import CardTypes from "service/constant/CardTypes";
import OrganService from "service/OrganService";
import TransactionService from "service/TransactionService";
import TimeRange from "service/constant/TimeRange";
import AuthStatus from "service/constant/AuthStatus";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "ZhifuCertification",
  components: {
    CommonTopForm,
    CommonTable,
    SelectOrgans,
    ShowInfoDialog,
    swiper,
    swiperSlide,
    ImageViewer,
  },
  data() {
    return {
      server: Server[process.env.NODE_ENV],
      imageUrl: [],
      formModel: {},
      authStatus: AuthStatus,
      cardTypes: CardTypes,
      tableData: [],
      page: {},
      isPage: false,
      submitService: TransactionService.zhifugetRauths,
      swiperOption: {
        loop: false,
        autoplay: false,
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false,
        // },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: false, //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  computed: {
    submitData() {
      const params = {
        userId: this.userId,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };

      return params;
    },
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getList();
  },
  methods: {
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        {
          userId: this.$route.params.id,
          current: this.isPage ? this.page.currentPage : 1,
          size: this.page.pageSize,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    handleDetail(row) {
      this.imageUrl = row;
      // this.imageUrl.push({
      //   id: "0",
      //   url: row.realImg,
      // });
      this.$refs.showInfoDialog.open();
    },
    countersign(row) {
      this.showConfirm("是否重新签约?")
        .then(() => {
          this.doCountersign(row.userId);
        })
        .catch(() => {});
    },
    doCountersign(userId) {
      this.doLoad(
        TransactionService.getStatus,
        {
          userId: userId,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
  },
};
</script>

<style scoped>
.bg {
  height: 500px;
}
.showImage {
  max-width: 100%;
  min-width: 500px;
  min-height: 500px;
  object-fit: contain;
}
.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/fragment/MemberManage/ZhifuCertification.vue